import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaUserCog,
  FaSpinner,
  FaUserShield,
  FaHistory,
  FaDollarSign,
  FaMoneyCheckAlt,
  FaMicrochip,
  FaCalendarTimes,
  FaChartLine,
  FaAddressCard,
  FaHandHoldingUsd,
  FaIndustry,
  FaChartBar,
  FaShieldAlt
} from "react-icons/fa";
import { SiXero } from "react-icons/si";
import {
  FaUsersViewfinder,
  FaCommentSms,
  FaUsers,
  FaFileInvoice,
  FaTimeline,
  FaUniversalAccess,
  FaFileInvoiceDollar
} from "react-icons/fa6";
import { AiOutlineDashboard, AiOutlineDollar } from "react-icons/ai";
import {
  MdOutlineMarkEmailRead,
  MdOutlineLeaderboard,
  MdMoney
} from "react-icons/md";
import { HiOutlineUserGroup, HiOutlineMailOpen } from "react-icons/hi";
import {
  TbReportAnalytics,
  TbDiscount2,
  TbClockDollar,
  TbPointerDollar,
  TbApiApp
} from "react-icons/tb";
import { LuFileClock, LuBellRing } from "react-icons/lu";
import { BsDatabaseFillGear } from "react-icons/bs";
import { TbFileDatabase } from "react-icons/tb";
import AllInvoiceData from "../../../pages/reports/AllInvoiceData";
import AllInvoiceBatchData from "../../../pages/reports/AllInvoiceBatchData";
import PropTypes from "prop-types";
import MigrationAction from "../../../pages/migration";
import {
  FMFB_TO_FR_PATH,
  FR_TO_FMFB_PATH,
  INVOICE_DATA_REPORT,
  ALL_INVOICE_BATCH_DATA_REPORT,
  MIGRATION_STATUS_PATH
} from "../../../route/paths";
import {
  FMFB_TO_FR,
  FR_TO_FMFB,
  STATUS
} from "../../../utils/constants/appConstants";

const SidebarLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  list-style: none;
  text-decoration: none;
`;
const SidebarNoLink = styled.span`
  display: flex;
  justify-content: space-between;
  list-style: none;
  text-decoration: none;
`;

const SidebarLabel = styled.span`
  margin-left: 10px;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinningIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  animation: ${spin} 1s linear infinite;
`;

const DropdownLink = styled(Link)`
  padding-left: 27px;
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const SubMenu = ({ item, handleClickMenuItemRemoveSidbar }) => {
  const iconMap = {
    FaUsersViewfinder: FaUsersViewfinder,
    AiOutlineDashboard: AiOutlineDashboard,
    HiOutlineUserGroup: HiOutlineUserGroup,
    TbReportAnalytics: TbReportAnalytics,
    FaFileInvoice: FaFileInvoice,
    FaMoneyCheckAlt: FaMoneyCheckAlt,
    MdOutlineMarkEmailRead: MdOutlineMarkEmailRead,
    AiOutlineDollar: AiOutlineDollar,
    MdOutlineLeaderboard: MdOutlineLeaderboard,
    FaUsers: FaUsers,
    FaUserCog: FaUserCog,
    FaUserShield: FaUserShield,
    LuFileClock: LuFileClock,
    FaDollarSign: FaDollarSign,
    FaHistory: FaHistory,
    HiOutlineMailOpen: HiOutlineMailOpen,
    FaCommentSms: FaCommentSms,
    TbDiscount2: TbDiscount2,
    LuBellRing: LuBellRing,
    TbPointerDollar: TbPointerDollar,
    TbClockDollar: TbClockDollar,
    TbApiApp: TbApiApp,
    FaMicrochip: FaMicrochip,
    FaCalendarTimes: FaCalendarTimes,
    FaChartLine: FaChartLine,
    FaAddressCard: FaAddressCard,
    FaHandHoldingUsd: FaHandHoldingUsd,
    FaIndustry: FaIndustry,
    FaChartBar: FaChartBar,
    FaTimeline: FaTimeline,
    FaUniversalAccess: FaUniversalAccess,
    FaShieldAlt: FaShieldAlt,
    SiXero: SiXero,
    MdMoney: MdMoney,
    BsDatabaseFillGear: BsDatabaseFillGear,
    TbFileDatabase: TbFileDatabase,
    FaFileInvoiceDollar: FaFileInvoiceDollar
  };
  const IconComponent = iconMap[item.icon];
  const location = useLocation();

  const [subnav, setSubnav] = useState(false);

  // Determine if this menu or any of its children is active
  const isActiveMenu =
    item.url &&
    (location.pathname === item.url ||
      location.pathname.startsWith(item.url + "/"));

  // Check if any of the children URLs match the current location
  const isActiveSubMenu =
    item.children &&
    item.children.some(
      (child) =>
        location.pathname === child.url ||
        location.pathname.startsWith(child.url + "/")
    );

  useEffect(() => {
    if (isActiveSubMenu) {
      setSubnav(true); // auto-expand submenu if active
    }
  }, [isActiveSubMenu]);

  const handleClick = () => {
    if (item.children && item.children.length > 0) {
      setSubnav(!subnav);
    }
    if (handleClickMenuItemRemoveSidbar) {
      handleClickMenuItemRemoveSidbar();
    }
  };

  const [showAllInvoiceData, setshowAllInvoiceData] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [showAllInvoiceBatchData, setshowAllInvoiceBatchData] = useState(false);
  const [isBatchDownloading, setIsBatchDownloading] = useState(false);

  const [migrationAction, setMigrationAction] = useState(null);
  return (
    <>
      {item.url ? (
        <SidebarLink
          to={item.url}
          onClick={handleClick}
          className={isActiveMenu ? "active-menu" : ""}
        >
          <span className="d-flex menu-item">
            {IconComponent && <IconComponent />}
            <SidebarLabel>{item.name}</SidebarLabel>
          </span>
          {item.children && item.children.length > 0 && (
            <span className="dropdown-icon">
              {subnav ? <FaMinusCircle /> : <FaPlusCircle />}
            </span>
          )}
        </SidebarLink>
      ) : (
        <SidebarNoLink
          onClick={
            item.children &&
            item.children.length > 0 &&
            (() => setSubnav(!subnav))
          }
          className={isActiveSubMenu ? "active-menu" : ""}
        >
          <span className="d-flex menu-item">
            {IconComponent && <IconComponent />}
            <SidebarLabel>{item.name}</SidebarLabel>
          </span>
          {item.children && item.children.length > 0 && (
            <span className="dropdown-icon">
              {subnav ? <FaMinusCircle /> : <FaPlusCircle />}
            </span>
          )}
        </SidebarNoLink>
      )}
      {item.children && item.children.length > 0 && subnav && (
        <ul className="sub-menu">
          {item.children
            .filter((subItem) => subItem.isActive !== false)
            .map((subItem) => {
              const IconChildrenComponent = iconMap[subItem.icon];
              const isInvoiceData = subItem.url === INVOICE_DATA_REPORT;
              const isInvoiceBatchData =
                subItem.url === ALL_INVOICE_BATCH_DATA_REPORT;
              const isMigrationAction =
                subItem.url === FMFB_TO_FR_PATH ||
                subItem.url === FR_TO_FMFB_PATH ||
                subItem.url === MIGRATION_STATUS_PATH;
              const isActiveChild =
                location.pathname === subItem.url ||
                location.pathname.startsWith(subItem.url + "/");
              const handleSubItemClick = (e) => {
                if (isInvoiceData) {
                  e.preventDefault();
                  setshowAllInvoiceData(true);
                  setIsDownloading(true);
                  return;
                }

                if (isInvoiceBatchData) {
                  e.preventDefault();
                  setshowAllInvoiceBatchData(true);
                  setIsBatchDownloading(true);
                  return;
                }

                if (isMigrationAction) {
                  e.preventDefault();
                  if (subItem.url === FMFB_TO_FR_PATH) {
                    setMigrationAction(FMFB_TO_FR);
                  } else if (subItem.url === FR_TO_FMFB_PATH) {
                    setMigrationAction(FR_TO_FMFB);
                  } else if (subItem.url === MIGRATION_STATUS_PATH) {
                    setMigrationAction(STATUS);
                  }
                  return;
                }

                if (handleClickMenuItemRemoveSidbar) {
                  handleClickMenuItemRemoveSidbar();
                }
              };

              return (
                <li key={subItem.id}>
                  <DropdownLink
                    to={
                      isInvoiceData || isInvoiceBatchData || isMigrationAction
                        ? "#"
                        : subItem.url
                    }
                    onClick={handleSubItemClick}
                    className={isActiveChild ? "active-menu" : ""}
                  >
                    {IconChildrenComponent && <IconChildrenComponent />}
                    <SidebarLabel>{subItem.name}</SidebarLabel>
                    {isInvoiceData && isDownloading && (
                      <SpinningIcon>
                        <FaSpinner />
                      </SpinningIcon>
                    )}
                    {isInvoiceBatchData && isBatchDownloading && (
                      <SpinningIcon>
                        <FaSpinner />
                      </SpinningIcon>
                    )}
                  </DropdownLink>
                </li>
              );
            })}
        </ul>
      )}
      {showAllInvoiceData && (
        <AllInvoiceData
          onDownloadComplete={() => {
            setIsDownloading(false);
            setshowAllInvoiceData(false);
          }}
        />
      )}
      {showAllInvoiceBatchData && (
        <AllInvoiceBatchData
          onDownloadComplete={() => {
            setIsBatchDownloading(false);
            setshowAllInvoiceBatchData(false);
          }}
        />
      )}
      {migrationAction && (
        <MigrationAction
          action={migrationAction}
          onComplete={() => setMigrationAction(null)}
        />
      )}
    </>
  );
};
SubMenu.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        url: PropTypes.string,
        name: PropTypes.string
      })
    )
  }).isRequired,
  handleClickMenuItemRemoveSidbar: PropTypes.func
};

export default SubMenu;
